export default {
  'MobileTechRow.TechRow': ({ tech }) => {
    window.location.pathname = `/techs/${tech.id}`
  },
  'MobileSideDropdown.Wrapper.Wrapper.CloseIcon': ({ }) => { }
}